export default "__VITE_ASSET__DzYsnjr1LtW1tBWqsYm2RQ__$_?component__"